/**
 * @license
 * Copyright 2012 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Enum for alignment of inputs.
 */
export enum Align {
  LEFT = -1,
  CENTRE = 0,
  RIGHT = 1,
}
